import {
  ArticleLocationSuggestionDifference,
  ArticleLocationSuggestionError,
} from "types";

export const isArticleLocationSuggestionError = (
  error: unknown,
): error is ArticleLocationSuggestionError =>
  Boolean(
    error &&
      typeof error === "object" &&
      "message" in error &&
      "suggestions" in error &&
      Array.isArray((error as ArticleLocationSuggestionError).suggestions),
  );

export const getArticleLocationSuggestionErrorMessage = (
  error: string | ArticleLocationSuggestionError,
) => {
  if (typeof error === "string") return error;
  return error.base_message ?? error.message;
};

export const formatArticleLocationSuggestionDifference = (
  difference: ArticleLocationSuggestionDifference,
) =>
  `${difference.label}: solicitado "${difference.expected}" | existente "${difference.actual}"`;
